import { render, staticRenderFns } from "./LearnSoccerWriteFormModal.vue?vue&type=template&id=23d5f124&scoped=true&"
import script from "./LearnSoccerWriteFormModal.vue?vue&type=script&lang=js&"
export * from "./LearnSoccerWriteFormModal.vue?vue&type=script&lang=js&"
import style0 from "./LearnSoccerWriteFormModal.vue?vue&type=style&index=0&id=23d5f124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d5f124",
  null
  
)

export default component.exports